// Single source of truth for timesheet-additional field labels.
// See timesheet-basic/labels.ts for context.

export const TIMESHEET_ADDITIONAL_TAB_SCOPE = 'timesheet-additional-settings'

export type TimesheetAdditionalTabId = 'a' | 'b' | 'c'

// Tabs:
// - 'a' = Event identification
// - 'b' = Additional options
// - 'c' = Presentation and print
export const TIMESHEET_ADDITIONAL_TAB_KEYS: Record<string, TimesheetAdditionalTabId> = {
  breaksMapping: 'a',
  mapActivitiesForMinimalWork: 'a',
  mapOnlyMinimalBreaks: 'a',
  activitiesMappingsConfiguration: 'a',
  plannedHoursRounding: 'b',
  calculationRounding: 'b',
  roundAllTimesheetEvents: 'b',
  notPaidLeaveAlywasReducePayment: 'b',
  euWorkAdditionalPaymentSplitProportionally: 'b',
  returnWeekDaysBeforeOverhours: 'b',
  postponeNotReturnedOverhours: 'b',
  addDeductionForOvertimeAtRequest: 'b',
  includeYearsAdditionInOverhoursRate: 'b',
  includeBonusInOverhoursRate: 'b',
  includeEuAdditionInOverhoursRate: 'b',
  includeEuWorkToPayInOverhoursRate: 'b',
  reduceBasePaymentOnLeaves: 'b',
  timesheetMinimalPeriods: 'b',
  shortBreakType: 'b',
  shortBreakMode: 'b',
  skipTaxExemptOutOfDate: 'b',
  printTimesheetAmounts: 'c',
  printForeignTimesheetToPayAmount: 'c',
  printTimesheetLeaveApplications: 'c',
  dispalyTimeSpanInDecimalFormat: 'c',
  printDutyOnTimesheet: 'c',
  showAmountsCoveredByLumpsum: 'c',
}

export const TIMESHEET_ADDITIONAL_LABEL_KEYS: Record<string, string> = {
  breaksMapping: 'configuration-timesheet.breaks-mapping',
  mapActivitiesForMinimalWork: 'configuration-timesheet.map-activities-for-eu',
  mapOnlyMinimalBreaks: 'configuration-timesheet.map-only-minimal-breaks',
  plannedHoursRounding: 'configuration-timesheet.round-planned-hours',
  calculationRounding: 'configuration-timesheet.round-calculation-values',
  roundAllTimesheetEvents: 'configuration-timesheet.round-all-components',
  notPaidLeaveAlywasReducePayment: 'configuration-timesheet.unpaid-leave-reduces-lumpsum',
  euWorkAdditionalPaymentSplitProportionally: 'configuration-timesheet.eu-payment-split-proportionally',
  returnWeekDaysBeforeOverhours: 'configuration-timesheet.return-weekdays-before-overhours',
  postponeNotReturnedOverhours: 'configuration-timesheet.postpone-overhours',
  addDeductionForOvertimeAtRequest: 'configuration-timesheet.deduction-for-overtime-request',
  includeYearsAdditionInOverhoursRate: 'configuration-timesheet.include-years-in-overhours',
  includeBonusInOverhoursRate: 'configuration-timesheet.include-bonus-in-overhours',
  includeEuAdditionInOverhoursRate: 'configuration-timesheet.include-eu-addition-in-overhours',
  includeEuWorkToPayInOverhoursRate: 'configuration-timesheet.include-eu-work-to-pay-in-overhours',
  reduceBasePaymentOnLeaves: 'configuration-timesheet.reduce-base-payment-on-leaves',
  timesheetMinimalPeriods: 'configuration-timesheet.minimal-periods-source',
  shortBreakType: 'configuration-timesheet.short-break-type',
  shortBreakMode: 'configuration-timesheet.short-break-mode',
  skipTaxExemptOutOfDate: 'configuration-timesheet.skip-tax-exempt-under26',
  printTimesheetAmounts: 'configuration-timesheet.print-amounts',
  printForeignTimesheetToPayAmount: 'configuration-timesheet.print-foreign-to-pay',
  printTimesheetLeaveApplications: 'configuration-timesheet.print-leave-applications',
  dispalyTimeSpanInDecimalFormat: 'configuration-timesheet.display-decimal-format',
  printDutyOnTimesheet: 'configuration-timesheet.print-duty',
  showAmountsCoveredByLumpsum: 'configuration-timesheet.lumpsum',
  activitiesMappingsConfiguration: 'configuration-timesheet.tab-event-identification',
}

export const buildTimesheetAdditionalDiffLabels = (
  t: (key: string) => string,
): Record<string, string> => {
  const out: Record<string, string> = {}
  for (const [field, labelKey] of Object.entries(TIMESHEET_ADDITIONAL_LABEL_KEYS)) {
    out[field] = t(labelKey)
  }
  return out
}
